export default __webpack_public_path__ + "static/tiktok-88c9890bfc461c1d7c82d7f0d9275f56.svg";